import { BASE_URL_API } from 'constants/base-url-default'

type Body = {
  name: string
  email: string
  password: string
}

export const registerUser = async (body: Body) => {
  const response = await fetch(`${BASE_URL_API}/users`, {
    method: 'POST',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('Sessão expirada')
    }
    throw new Error('Erro ao registrar usuário.')
  }
}
